/**
 * Injects the Google Tag Manager loader.
 *
 * Container ID comes from runtime config (NUXT_PUBLIC_GTM_ID) so a single build can target
 * different containers per environment. Leave it unset to disable GTM entirely — the local
 * default, which also stops the loader requesting /undefined paths.
 *
 * NUXT_PUBLIC_GTM_LOAD_STRATEGY picks when the container script downloads:
 * - `eager` (default): straight away from <head>, so its tags run alongside hydration.
 * - `idle`: once the app has hydrated and the main thread is idle. The `gtm.js` event is still queued
 *   first, so tags fire in the same order, but a visit that ends before the script loads sends none.
 */
export default defineNuxtPlugin(() => {
  const { gtmId, gtmLoadStrategy } = useRuntimeConfig().public

  if (!gtmId) return

  if (gtmLoadStrategy !== 'idle') {
    useHead({
      script: [
        {
          innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtmId}');`,
        },
      ],
    })
    return
  }

  useHead({
    script: [
      {
        innerHTML: `window.dataLayer=window.dataLayer||[];dataLayer.push({'gtm.start':new Date().getTime(),event:'gtm.js'});`,
      },
    ],
  })
  if (import.meta.client) {
    onNuxtReady(() =>
      injectClientSideScripts([
        { id: 'gtm-script', src: `https://www.googletagmanager.com/gtm.js?id=${gtmId}`, async: true },
      ]),
    )
  }
})
